import React from 'react';
import { FiUser, FiGlobe } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { CampoTexto } from './CamposFormulario';
import { normalizarTelefonoInternacional } from '../../../../utils/telefono';

/** Datos de contacto del usuario. Visible para admin y técnico. */
const FormularioInformacion = ({ usuarioData, form, errores, onCampo }) => {
  const { t } = useTranslation();
  const cambiar = (e) => onCampo(e.target.name, e.target.value);

  return (
    <>
      <section className="pu-form-bloque">
        <h4 className="pu-form-seccion"><FiUser /> {t('perfilUsuario.datosPersonales')}</h4>

        <div className="pu-campo">
          <label htmlFor="campo-usuario">{t('comun.usuario')}</label>
          <span className="pu-campo-hint" id="campo-usuario-hint">
            {t('perfilUsuario.identificadorAcceso')}
          </span>
          <input
            id="campo-usuario"
            type="text"
            value={`@${usuarioData.usuario}`}
            aria-describedby="campo-usuario-hint"
            disabled
          />
        </div>

        <div className="pu-form-grid">
          <CampoTexto
            id="campo-nombre"
            name="nombre"
            label={t('comun.nombre')}
            autoComplete="given-name"
            value={form.nombre}
            onChange={cambiar}
            error={errores.nombre}
          />
          <CampoTexto
            id="campo-apellidos"
            name="apellidos"
            label={t('comun.apellidos')}
            autoComplete="family-name"
            value={form.apellidos}
            onChange={cambiar}
            error={errores.apellidos}
          />
        </div>

        <div className="pu-form-grid">
          <CampoTexto
            id="campo-email"
            name="email"
            label={t('comun.email')}
            type="email"
            autoComplete="email"
            value={form.email}
            onChange={cambiar}
            error={errores.email}
          />
          <CampoTexto
            id="campo-telefono"
            name="telefono"
            label={t('comun.telefono')}
            type="tel"
            inputMode="tel"
            autoComplete="tel"
            hint={t('perfilUsuario.telefonoInternacionalHint')}
            placeholder={t('perfilUsuario.telefonoInternacionalPlaceholder')}
            value={form.telefono}
            onChange={cambiar}
            onBlur={() => onCampo('telefono', normalizarTelefonoInternacional(form.telefono))}
            error={errores.telefono}
          />
        </div>
      </section>

      <section className="pu-form-bloque">
        <h4 className="pu-form-seccion"><FiGlobe /> {t('perfilUsuario.sitiosCliente')}</h4>

        <CampoTexto
          id="campo-webs"
          name="webs_del_cliente"
          label={t('perfilUsuario.websAsociadas')}
          hint={t('perfilUsuario.websAsociadasHint')}
          placeholder={t('perfilUsuario.websAsociadasPlaceholder')}
          value={form.webs_del_cliente}
          onChange={cambiar}
        />
      </section>
    </>
  );
};

export default FormularioInformacion;
